import EL, { HTMLELEMENT } from '../../EL/EL.js';
import ICON from '../../SVG/icon/ICON.js';
import SPAN from '../../DOM/span/SPAN.js';
import { BUTTONTYPES } from '../../../enums/BUTTONTYPES.js';
import { makeAttrStruct } from '../../../enums/ModelAttr.js';
import { makeStruct } from '../../../enums/MODELS.js';
import { makeDataStruct } from '../../../enums/ModelData.js';
import Clickable from '../../../interface/Clickable.js';
import Translatable from '../../../interface/Translatable.js';
// Model Structure
export const buttonAttr = makeAttrStruct([
    ['name'],
    ['title'],
    ['class'],
    ['type', BUTTONTYPES.BUTTON],
    ['disabled']
]);
export const buttonData = makeDataStruct([
    ['span'],
    ['icon']
]);
export const buttonModel = makeStruct([
    ['attributes', buttonAttr],
    ['data', buttonData]
]);
// Simplified Model
export function button(span, name, icon, title, className, type, disabled) {
    return {
        attributes: buttonAttr(name, title, className, type, disabled),
        data: buttonData(span, icon)
    };
}
/** A generic BUTTON Element with an Icon and Label */
export default class BUTTON extends EL {
    icon;
    constructor(node, model) {
        super(node, HTMLELEMENT.BUTTON, model);
        this.implement(new Clickable(this));
        this.addClass('btn');
        this.icon = new ICON(this, model.data.icon);
        this.label = new SPAN(this, model.data.span).addClass('btn-label');
        this.label.implement(new Translatable(this.label));
        if (model.attributes.title) {
            this.setTitle(model.attributes.title);
        }
    }
    /** Sets the Button Icon */
    setIcon(model) {
        if (this.icon === null) {
            this.icon = new ICON(this, model);
        }
        else {
            this.icon.destroy().then((success) => {
                if (success) {
                    this.icon = new ICON(this, model);
                    this.data.icon = model;
                }
                else {
                    console.log('failed to destroy');
                }
            });
        }
        return this;
    }
    setIconText(text) {
        this.icon.svg.get(null, 'text')[0].setInnerHTML(text);
        return this;
    }
    /** Sets the label within the button to the given string */
    setLabel(text = '') {
        this.data.span.data.text = text;
        this.label.setInnerHTML(text);
        return this;
    }
    getLabel() {
        return this.data.span.data.text;
    }
}
